import axios from 'axios'

// 获取按钮权限
export function queryButtonPermission (datas) {
  const url = `/customerLogin/queryButtonPermission`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 查询机器人分类列表
export function getProblemType (datas) {
  const url = `/problemType/queryProblemTypePage`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 编辑回显机器人分类
export function returnProblemType (datas) {
  const url = `/problemType/editReturnProblemType`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 编辑提交机器人分类
export function editProblemType (datas) {
  const url = `/problemType/editProblemType`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
// 新增机器人分类
export function addProblemType (datas) {
  const url = `/problemType/addProblemType`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/robotSort/index.js